import { render, staticRenderFns } from "./TwoTableOperateDataLog.vue?vue&type=template&id=ec9b4650"
import script from "./TwoTableOperateDataLog.vue?vue&type=script&lang=js"
export * from "./TwoTableOperateDataLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports